import React from 'react';

const Categoriessec = () => (
  <>
    <p className="text">Still Under Construction</p>
  </>
);

export default Categoriessec;
